<template>
  <div class="aside">
    <!-- 关注 -->
    <div class="guanzhu" v-show="ziji">
      <div class="gz" @click="gz">
        <p>关注</p>
        <span>{{ getSpace_data.myfollow }}</span>
      </div>
      <div class="fs" @click="fs">
        <p>粉丝</p>
        <span>{{ getSpace_data.follow }}</span>
      </div>
    </div>
    <!-- 说说、日志。相册 -->
    <div class="shuoshuo">
      <div class="ss" @click="shuoshuo">
        <p>说说</p>
        <span class="yangshi">{{ getSpace_data.dynamic_count }}</span>
      </div>
      <div class="rz" @click="rizhi">
        <p>日志</p>
        <span class="yangshi">{{ getSpace_data.notice_count }}</span>
      </div>
      <div class="xc" @click="xiangce">
        <p>相册</p>
        <span class="yangshi">{{ getSpace_data.photo_count }}</span>
      </div>
    </div>

    <!-- 个人信息列表 -->
    <div class="othersmes bord4" v-show="personalInfo">
      <div class="clear">
        <i class="iconfont icondingwei"></i>
        <div>{{ getSpace_data.space_name }}</div>
      </div>
      <div class="clear">
        <i class="iconfont iconxuexiao"></i>
        <div>就读：{{ getSpace_data.shcool_name }}</div>
      </div>
      <div class="clear">
        <i class="iconfont iconshengri"></i>
        <div>生日：{{ getSpace_data.birthday }}</div>
      </div>
      <div class="qianmingposi clear">
        <i class="iconfont iconqianming"></i>
        <div class="ifshow">个性签名：{{ getSpace_data.space_brief }}</div>
      </div>
      <div style="text-align: center; color: #4d4d4d" @click="router">
        <span>查看更多<span class="el-icon-arrow-right"></span></span>
      </div>
    </div>

    <!-- 今日推荐、 -->
    <div class="today">
      <div class="tuijian">
        <i class="iconfont icontuijian"></i>
        <span>今日推荐</span>
      </div>
      <div class="list">
        <ul>
          <li v-for="item in list" :key="item.id">
            <div class="img_header" @click="other(item)">
              <div class="img">
                <img
                  :src="item.space_avatar"
                  v-if="item.space_avatar != '' && item.space_avatar != ' '"
                />
                <img src="../../assets/photoico.png" v-else />
              </div>
              <div class="infomation">
                <p>{{ item.space_name }}</p>
                <span>{{ item.is_follow }} 粉丝</span> |
                <span>{{ item.dynamics_num }} 说说</span>
              </div>
            </div>
            <div
              @click="guanzhu(item)"
              class="anniu"
              :class="{ actives: item.is_follow == 1 }"
            >
              {{ item.is_follow == 0 ? "关注" : "已关注" }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import URL from "../../api/index";
import VueEvent from "../../api/eventBus";
import { getRandomArrayElements } from "../../api/http";
import axios from "axios";

export default {
  inject: ["reload"],
  data() {
    return {
      personalInfo: true,
      getSpace_data: "",
      list: [],
      UserInfo: "",
      getSpaceinfo: "",
      iteminfo: "",
      spaceid: "",
      option: [],
      ziji: true,
    };
  },
  created() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.spaceid = this.iteminfo.space_id;
    } else {
      this.spaceid = this.getSpaceinfo.space_id;
    }
    this.chaxun();
  },
  mounted() {
    this.tuijian();
    if (this.iteminfo) {
      this.ziji = false;
    }
  },
  methods: {
    other(e) {
      localStorage.setItem("iteminfo", JSON.stringify(e));
      if (this.getSpaceinfo.space_id == e.space_id) {
        localStorage.removeItem("iteminfo");
        this.$router.push("/space/saying");
      }
      if (this.$route.path == "/space/saying") {
        this.reload();
      } else {
        this.$router.push("/space/saying");
      }
    },
    chaxun() {
      var that = this;
      var getspace_data = {
        token: that.UserInfo.token,
        spaceid: that.spaceid,
      };
      // 查询空间
      this.$post(URL.getSpace, getspace_data).then((res) => {
        that.getSpace_data = res.result;
        // console.log(that.getSpace_data);
        VueEvent.$emit("ziliao", that.getSpace_data);
      });

      if (this.$route.path == "/space/userifon") {
        this.personalInfo = false;
      }
    },
    tuijian() {
      var that = this;
      var getSpaceList_data = {
        token: that.UserInfo.token,
      };
      // 今日推荐
      this.$post(URL.getSpaceList, getSpaceList_data).then((res) => {
        that.list = getRandomArrayElements(res.result, 4);
      });
    },
    // 关注数据上报
    getRecordFollow(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_attention",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark:
            `${hh.user_nicename}` + "使用了网络学习空间今日推荐关注功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            unfollow_id: row.space_id,
            unfollow_name: row.space_name,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 取消关注数据上报
    getRecordRjw(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_attentioncancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark:
            `${hh.user_nicename}` + "使用了网络学习空间今日推荐取消关注功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            unfollow_id: row.space_id,
            unfollow_name: row.space_name,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },

    guanzhu(e) {
      // console.log(e);
      e.is_follow = e.is_follow == "1" ? "0" : "1";
      if (e.is_follow == "1") {
        // 关注 数据上报
        this.getRecordFollow(JSON.parse(localStorage.getItem("loginInfo")), e)
        var addMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 关注空间
        this.$post(URL.addMyFollowSpace, addMyFollowSpace_data).then((res) => {
          this.chaxun();
        });
      } else if (e.is_follow == "0") {
        //  取消关注 数据上报
        this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")), e);
        var delMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 取消关注空间
        this.$post(URL.delMyFollowSpace, delMyFollowSpace_data).then((res) => {
          this.chaxun();
        });
      }
    },
    router() {
      this.$router.push("/space/UserIfon");
    },
    shuoshuo() {
      this.$router.push("/space/saying");
    },
    rizhi() {
      this.$router.push("/space/journal");
    },
    xiangce() {
      this.$router.push("/space/ablum");
    },
    gz() {
      this.$router.push("/space/guanzhu");
    },
    fs() {
      this.$router.push("/space/fensi");
    },
  },
};
</script>

<style lang="less" scoped>
.aside {
  width: 295px;
}
.guanzhu,
.shuoshuo {
  width: 294px;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  overflow: hidden;
  padding-top: 25px;
  div {
    float: left;
    text-align: center;
    box-sizing: border-box;
    p {
      font-size: 16px;
      color: #3c495c;
      margin-bottom: 15px;
    }
    span {
      font-size: 24px;
      color: #3c495c;
    }
  }
}
.guanzhu {
  div {
    width: 50%;
  }
  .gz {
    border-right: 1px solid #dfdfdf;
    cursor: pointer;
  }
  .fs {
    cursor: pointer;
  }
}
.shuoshuo {
  margin: 15px 0;
  div {
    width: 33.33%;
  }
  span {
    line-height: 24px;
  }
  .ss,
  .rz {
    cursor: pointer;
    border-right: 1px solid #dfdfdf;
    .yangshi {
      display: inline-block;
      // border-bottom: 1px solid #898989;
    }
  }
  .xc {
    cursor: pointer;
    .yangshi {
      display: inline-block;
      // border-bottom: 1px solid #898989;
    }
  }
}
.actives {
  opacity: 0.6;
}
.today {
  width: 294px;

  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  .tuijian {
    padding-top: 16px;
    font-size: 16px;
    color: #000;
    i {
      font-size: 22px;
      color: #2c84ff;
      margin: 0 10px 0 20px;
      vertical-align: middle;
    }
  }
  .list {
    ul {
      overflow: hidden;
      margin-left: 12px;
      padding-bottom: 20px;
      li {
        float: left;
        width: 272px;
        padding: 10px 0;
        border-bottom: 1px solid #efefef;
        position: relative;
        .anniu {
          float: right;
          width: 4em;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 26px;
          margin: auto;
          border-radius: 5px;
          background-color: #409eff;
          position: absolute;
          top: 50%;
          right: -8%;
          transform: translate(-50%, -50%);
          cursor: pointer;
        }
        .img_header {
          float: left;

          .img {
            padding: 8px 14px 0 3px;
            float: left;
            img {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              overflow: hidden;
              cursor: pointer;
            }
          }
          .infomation {
            float: left;
            color: #898989;
            p {
              padding: 7px 0 4px 0;
              font-size: 14px;
              color: #000;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
            }
            span {
              font-size: 12px;
            }
          }
        }
        .el-button,
        .el-tag {
          float: right;
          margin-top: 15px;
        }
      }
    }
  }
}

.othersmes {
  margin-bottom: 15px;
  background: #fff;
  padding: 0 15px;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
}
.othersmes > div {
  font-size: 14px;
  line-height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.othersmes > div:last-child {
  border-bottom: 0;
  cursor: pointer;
}
.othersmes > div i {
  color: #c2c5c9;
  float: left;
  font-size: 24px;
  margin: 0 15px 0 10px;
}
.qianmingposi {
  line-height: 30px !important;
  padding: 10px 0;
}
.ifshow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.othersmes > div div {
  color: #898989;
}
</style>